export const userRoutes = [
    {
        name: "user",
        path: "/user/:userName?",
        component: () => import("@/app/users/User"),
        props: true
    },
    {
        name: "user-credentials",
        path: "/user-credentials",
        component: () => import("@/app/users/UserCredential"),
        props: true
    },
    {
        name: "change-credentials",
        path: "/change-credentials",
        component: () => import("@/app/users/UserPasswordReset"),
        props: true
    },
    {
        name: "user-list",
        path: "/users",
        component: () => import("@/app/users/UserList"),
        props: true
    },
    {
        name: "user-detail",
        path: "/user-detail/:userName?",
        component: () => import("@/app/users/UserDetail"),
        props: true        
    }

]